import './programs.component.scss'

class ProgramHarm {
  constructor(wrapEl) {
    this.list = wrapEl.querySelectorAll('.programs-item_expand')
  }

  calcHeight(list) {
    let res = 0
    for(let count = 0; count < list.length; count++) {
      res += list[count].offsetHeight
    }
    return res
  }

  isOpened(item) {
    return item.classList.contains('opened')
  }

  onClick(event) {
    const head = event.currentTarget
    const item = head.closest('.programs-item_expand')
    const body = item.querySelector('.programs-item__body')

    const isTip = event.target.closest('.programs-line__tip')

    if (!isTip) {
      item.classList.toggle('opened')
  
      const isOpened = this.isOpened(item)
      
      if (isOpened) {
        const height = this.calcHeight(body.children)
  
        body.style.height = `${height}px`
        body.addEventListener('transitionend', () => {
          if (body.style.height) {
            body.style.height = 'auto'
          }
        }, { once: true })
      } else {
        const height = this.calcHeight(body.children)
  
        body.style.height = `${height}px`
  
        setTimeout(() => {
          body.removeAttribute('style')
        }, 0)
      }
    }
  }

  init() {
    this.list.forEach(item => {
      const head = item.querySelector('.programs-item__head')

      head.addEventListener('click', this.onClick.bind(this))
    })
  }
}

class ProgramTip {
  constructor(el) {
    this.el = el
    this.btn = el.querySelector('.programs-line__tip-btn')
  }

  toggle() {
    this.el.classList.toggle('opened')

    if (this.el.classList.contains('opened')) {
      const setClose = () => {
        window.addEventListener('click', e => {
          if (!this.el.contains(e.target)) {
            this.el.classList.remove('opened')
          } else {
            setClose()
          }
        }, { once: true })
      }
      setClose()
    }
  }

  init() {
    this.btn.addEventListener('click', this.toggle.bind(this))
  }
}

class ProgramDescription {
  constructor(el, classes, text) {
    this.el = el
    this.btn = el.querySelector(`.${classes.btn}`)
    this.content = el.querySelector(`.${classes.content}`)
    this.btnText = {
      closed: text.closed,
      opened: text.opened
    }
  }

  checkState() {
    if (this.content.dataset.expanded === 'false') {
      return false
    } else if (this.content.dataset.expanded === 'true') {
      return true
    }
  }

  toggle(event) {
    event.preventDefault()
    if (this.checkState()) {
      this.btn.innerHTML = this.btnText.closed
      this.content.dataset.expanded = 'false'
    } else {
      this.btn.innerHTML = this.btnText.opened
      this.content.dataset.expanded = 'true'
    }
  }

  init() {
    this.btn.addEventListener('click', this.toggle.bind(this))
  }
}

const programsEl = document.querySelector('.programs')
if (programsEl) {
  const tableToggling = () => {
    const programTablesEl = programsEl.querySelectorAll('.programs-table')
    
    programTablesEl.forEach(item => {
      const harm = new ProgramHarm(item)
      harm.init()
    })
  }
  const tipsToggling = () => {
    const tipsList = programsEl.querySelectorAll('.programs-line__tip')

    tipsList.forEach(item => {
      const tip = new ProgramTip(item)
      tip.init()
    })
  }
  const featuresDescriptions = () => {
    const list = programsEl.querySelectorAll('.programs-features__card')
    list.forEach(item => {
      const item__btnClass = 'programs-features__link'
      const item__btn = item.querySelector(`.${item__btnClass}`)
      const item__full = item.querySelector('.programs-features__text_full')

      if (item__btn && item__full) {
        const description = new ProgramDescription(item, 
          {
            btn: item__btnClass, 
            content: 'programs-features__content'
          }, {
            opened: 'Hide description',
            closed: item__btn.innerHTML
          })
        description.init()
      }
    })
  }

  const horisontalScrolls = () => {
    const horizontalScrolled = document.querySelector('.programs__scrollable')
    if (horizontalScrolled) {
      horizontalScrolled.addEventListener('scroll', event => {
        const elem = event.target
        const currentScroll = elem.scrollLeft
        if (currentScroll > 5) {
          elem.classList.add('scrolled')
        } else {
          elem.classList.remove('scrolled')
        }
      })
    }
  }

  tableToggling()
  tipsToggling()
  featuresDescriptions()
  horisontalScrolls()
}